module.exports = __webpack_public_path__ + "img/1.94ad1bc5.png";